module.exports = __webpack_public_path__ + "img/19.a7499893.png";